import { extendTheme } from "@chakra-ui/react";

const config = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  fonts: {
    heading: "Poppins, sans-serif",
    body: "Inter, sans-serif",
  },
  styles: {
    global: {
      body: {
        bg: "#1A202C",
        color: "#F7FAFC",
        fontFamily: "Inter, sans-serif",
        lineHeight: "1.6",
      },
      h1: {
        fontFamily: "Poppins, sans-serif",
        fontWeight: "700",
      },
      h2: {
        fontFamily: "Poppins, sans-serif",
        fontWeight: "600",
      },
      h3: {
        fontFamily: "Poppins, sans-serif",
        fontWeight: "600",
      },
      h4: {
        fontFamily: "Poppins, sans-serif",
        fontWeight: "500",
      },
      h5: {
        fontFamily: "Poppins, sans-serif",
        fontWeight: "500",
      },
      h6: {
        fontFamily: "Poppins, sans-serif",
        fontWeight: "500",
      },
      a: {
        transition: "all 0.3s ease-in-out",
        _hover: {
          textDecoration: "none",
        }
      },
      section: {
        py: { base: "4rem", md: "6rem" },
      },
    },
  },
  colors: {
    brand: {
      primary: "#1A202C",
      secondary: "#3182CE",
      accent: "#F6AD55",
      subtle: "#2D3748",
      text: {
        primary: "#F7FAFC",
        secondary: "#E2E8F0",
        accent: "#63B3ED",
        muted: "#A0AEC0",
      },
      bg: {
        card: "rgba(45, 55, 72, 0.8)",
        hover: "rgba(49, 130, 206, 0.1)",
        section: "#2A4365",
        dark: "#101522",
      }
    },
    gray: {
      50: "#F7FAFC",
      100: "#EDF2F7",
      200: "#E2E8F0",
      300: "#CBD5E0",
      400: "#A0AEC0",
      500: "#718096",
      600: "#4A5568",
      700: "#2D3748",
      800: "#1A202C",
      900: "#171923",
    },
  },
  components: {
    Button: {
      defaultProps: {
        colorScheme: "blue",
      },
      baseStyle: {
        fontWeight: "500",
        borderRadius: "0.375rem",
        transition: "all 0.3s ease",
        _hover: {
          transform: "translateY(-2px)",
          boxShadow: "lg",
        },
      },
      variants: {
        solid: {
          bg: "#3182CE",
          color: "white",
          _hover: {
            bg: "#2B6CB0",
          },
        },
        outline: {
          borderColor: "#3182CE",
          color: "#3182CE",
          _hover: {
            bg: "rgba(49, 130, 206, 0.1)",
          },
        },
        ghost: {
          _hover: {
            bg: "rgba(255, 255, 255, 0.1)",
          },
        },
      },
    },
    Heading: {
      baseStyle: {
        color: "brand.text.primary",
        fontWeight: "semibold",
        letterSpacing: "-0.02em",
      },
    },
    Text: {
      baseStyle: {
        color: "brand.text.primary",
      },
    },
    Card: {
      baseStyle: {
        bg: "brand.bg.card",
        borderRadius: "lg",
        overflow: "hidden",
        transition: "all 0.3s ease",
        boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        _hover: {
          transform: "translateY(-4px)",
          boxShadow: "0 10px 15px rgba(0,0,0,0.2)",
        },
      },
    },
    Container: {
      baseStyle: {
        maxW: "1200px",
        px: { base: "1rem", md: "2rem" },
      },
    },
    Link: {
      baseStyle: {
        color: "brand.text.primary",
        _hover: {
          textDecoration: "none",
          color: "brand.secondary",
        },
      },
    },
  },
  space: {
    section: { base: "4rem", md: "6rem" },
  },
  shadows: {
    subtle: "0 2px 8px rgba(0,0,0,0.1)",
    card: "0 4px 12px rgba(0,0,0,0.15)",
    elevated: "0 8px 24px rgba(0,0,0,0.2)",
  },
  breakpoints: {
    sm: "30em",
    md: "48em",
    lg: "62em",
    xl: "80em",
    "2xl": "96em",
  },
});

export default theme; 